import { render, staticRenderFns } from "./authModal.vue?vue&type=template&id=09bb090e&scoped=true&"
import script from "./authModal.vue?vue&type=script&lang=ts&"
export * from "./authModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bb090e",
  null
  
)

export default component.exports